import React from 'react';
import ReactDOM from 'react-dom';
import { StatusUpdateItem } from './status_update_item';

const createReactClass = require('create-react-class');

const StatusUpdateResults = createReactClass({
  componentDidMount() {
    $('.dashboard-feed').delegate('#load_more', 'ajax:complete', (event, data) => {
      data = $.parseJSON(data.responseText);
      const $dashboardFeed = $('.dashboard-feed');
      const $loading = $("<div id='loading'></div>");
      $loading.appendTo($dashboardFeed);
      if (data.status_updates) {
        const component = React.createElement(StatusUpdateResults, { status_updates: data.status_updates });
        ReactDOM.render(component, $loading[0]);
      }
      $loading
        .children()
        .first()
        .children();
      $loading.children().unwrap();
      if (data.next_link) {
        const loadMoreParent = $('#load_more').parents('.comment.load-more');
        loadMoreParent.remove();
        $('.dashboard-feed').append(loadMoreParent);
        $('#load_more').remove();
        loadMoreParent.find('h3').append(data.next_link);
      } else {
        $('#load_more')
          .parents('.comment.load-more')
          .addClass('hidden');
      }
    });
  },
  renderStatusUpdates() {
    return this.props.status_updates.map(s => {
      return <StatusUpdateItem status_update={s.status_update || s} />;
    });
  },
  render() {
    return <div>{this.renderStatusUpdates()}</div>;
  }
});

export { StatusUpdateResults };
